import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-pdf-viewer.SomeClass',
  templateUrl: './pdf-viewer.component.html'
})
export class PdfViewerComponent implements OnInit {
  @Input() blob:Blob;
  @Input() fileName:string;
  private blobUrl:string;
  pdfUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer, public modal:NgbActiveModal) { }

  ngOnInit(): void {
    this.blobUrl = URL.createObjectURL(this.blob);
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl);
  }

  download() {
    saveAs(this.blob, this.fileName);
  }

  viewDocument() {
     window.open(URL.createObjectURL(this.blob));
   }

  close() {
    URL.revokeObjectURL(this.blobUrl);
    this.modal.close();
  }

  static showPdf(modals:NgbModal, blob:Blob, fileName:string) {
    const modal = modals.open(PdfViewerComponent, { windowClass: 'maximized-modal', backdrop: 'static' });
    (modal.componentInstance as PdfViewerComponent).blob = blob;
    (modal.componentInstance as PdfViewerComponent).fileName = fileName;
  }
}
